<template>
  <PageLayout>
    <template #main>
      <PageHeaderSmall  class="my-2"
                        :title="$t('Webportal.PerformanceMatrix')"
                        :description="$t('Webportal.PerformanceByCountry')" />
      <SmallFilterRow v-model="selectedFilter"
                      :options="filterOptions"
                      :disabled="true"
                      class="my-4"
                      @add-filter="handleAddFilter" />
      <MatrixBoard />


    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/componentsv3/PageLayout.vue';
import PageSidebar from '@/componentsv3/PageSidebar.vue';
import PageHeaderSmall from '@/componentsv3/PageHeaderSmall.vue';
import SmallFilterRow from '@/componentsv3/SmallFilterRow.vue';
import MatrixBoard from '@/componentsv3/MatrixBoard/MatrixBoard.vue';
import DashboardService from '@/services/DashboardService-APP_TARGET';
import EventBus from "@/services/EventBus";
import CancelToken from '@/mixins/CancelToken';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Matrix',
  mixins: [CancelToken],
  components: {
    MatrixBoard,
    PageHeaderSmall,
    PageLayout,
    PageSidebar,
    SmallFilterRow
  },

  data() {
    return {
      dashboardData: null,
      dashboardDataCancelToken: null,
      selectedFilter: 'all',
      filterOptions: [
        { value: 'all', label: 'All Details' },
        { value: 'medium', label: 'Medium' },
        { value: 'minimal', label: 'Minimal' }
      ]
    }
  },

  async mounted() {
    EventBus.$on('app.ready', this.loadOverviewData);
    if (this.isClientReady && this.filters && !this.dashboardData) {
      this.loadOverviewData();
    }
  },

  beforeUnmount() {
    EventBus.$off('app.ready', this.loadOverviewData);
  },

  methods: {
    ...mapActions('clientData', [ 'setAppLoading' ]),

    handleAddFilter() {
      log.log('Add filter clicked');
    },

    async loadOverviewData() {
      this.setAppLoading(true);
      // DELAY 2000 ms for testing
      // await new Promise(resolve => setTimeout(resolve, 2000));
      const filter = {
        client: this.clientId,
        waves: this.filters?.waves?.map(x => x.id).join(','),
        surveys: this.filters?.waves?.map(x => x.surveyId).join(','),
      };

      this.dashboardDataCancelToken = this.initCancelToken(this.dashboardDataCancelToken);
      await DashboardService.getDashboard(filter, this.dashboardDataCancelToken, this.currentLocale)
        .then(response => {
          log.warn("RES:  ", response);
          this.dashboardData = response.data;
          // this.columns = this.getClusters();
          // this.getKpiColumns();
        })
        .catch(error => {
          log.error('Error loading overview data:', error);
        })
        .finally(() => {
          this.setAppLoading(false);
        });
    },
  }
}
</script>
<!--
<style lang="scss">
.container-fluid {
  padding-left: unset !important;
  padding-right: unset !important;
}
</style> -->
